import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

const axiosInstance: AxiosInstance = axios.create({
  withCredentials: true,
  timeout: 8000,
});

axiosInstance.interceptors.response.use(
  (response: AxiosResponse) => {
    // if (import.meta.env.DEV || window.__KCW_DEBUG__) {
    console.log("🚀 ~ response:", response);
    // }
    return response;
  },
  (error: AxiosError) => {
    if (error.response && error.response.status === 401) {
      console.warn("Interceptor error headers: ", error.response.headers);
    }

    return Promise.reject(error);
  },
);

export default axiosInstance;
